/* global axios */

import ApiClient from './ApiClient';

class QrCodeApi extends ApiClient {
  constructor() {
    super('qrcode', { accountScoped: true });
  }

  instanceCreate(payload) {
    return axios.post(`${this.url}/evolution`, payload, {
      headers: {
        'Content-Type': 'application/json',
        path: '/instance/create',
      },
    });
  }

  instanceConnect(instanceName) {
    return axios.get(`${this.url}/evolution`, {
      headers: {
        'Content-Type': 'application/json',
        path: `/instance/connect/${instanceName}`,
      },
    });
  }

  instanceLogout(instanceName) {
    return axios.delete(`${this.url}/evolution`, {
      headers: {
        'Content-Type': 'application/json',
        path: `/instance/logout/${instanceName}`,
      },
    });
  }

  instanceLogoutFromOldApi(instanceName) {
    return axios.delete(`${this.url}/evolution`, {
      headers: {
        'Content-Type': 'application/json',
        path: `/instance/logout/${instanceName}`,
        'x-api-server': 'evo',
      },
    });
  }

  getInstanceConnectionState(instanceName) {
    return axios.get(`${this.url}/evolution`, {
      headers: {
        'Content-Type': 'application/json',
        path: `/instance/connectionState/${instanceName}`,
      },
    });
  }

  getInstanceConnectionStateFromOldApi(instanceName) {
    return axios.get(`${this.url}/evolution`, {
      headers: {
        'Content-Type': 'application/json',
        path: `/instance/connectionState/${instanceName}`,
        'x-api-server': 'evo',
      },
    });
  }

  async getInstanceDataFromOldApi(instanceName) {
    const evo_settings = await axios.get(`${this.url}/evolution`, {
      headers: {
        'Content-Type': 'application/json',
        path: `/settings/find/${instanceName}`,
        'x-api-server': 'evo',
      },
    });

    const evo_chatwoot = await axios.get(`${this.url}/evolution`, {
      headers: {
        'Content-Type': 'application/json',
        path: `/chatwoot/find/${instanceName}`,
        'x-api-server': 'evo',
      },
    });

    return {
      evo_settings,
      evo_chatwoot,
    };
  }

  getSettings(instanceName) {
    return axios.get(`${this.url}/evolution`, {
      headers: {
        'Content-Type': 'application/json',
        path: `/settings/find/${instanceName}`,
      },
    });
  }

  setSettings(instanceName, payload) {
    return axios.post(`${this.url}/evolution`, payload, {
      headers: {
        'Content-Type': 'application/json',
        path: `/settings/set/${instanceName}`,
      },
    });
  }

  getChatwoot(instanceName) {
    return axios.get(`${this.url}/evolution`, {
      headers: {
        'Content-Type': 'application/json',
        path: `/chatwoot/find/${instanceName}`,
      },
    });
  }

  setChatwoot(instanceName, payload) {
    return axios.post(`${this.url}/evolution`, payload, {
      headers: {
        'Content-Type': 'application/json',
        path: `/chatwoot/set/${instanceName}`,
      },
    });
  }
}

export default new QrCodeApi();
